import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';

const IcoDots = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><circle cx="5" cy="12" r="1.7" /><circle cx="12" cy="12" r="1.7" /><circle cx="19" cy="12" r="1.7" /></svg>
);

// Только одно меню открыто одновременно (закрываем предыдущее при открытии нового).
let openMenuRef = null;

// Меню «три точки» — портал в body (не режется overflow-ом карточек), открывается вверх если снизу мало места.
export default function CardMenu({ items }) {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState(null);
  const btnRef = useRef(null);
  const selfRef = useRef(null);
  selfRef.current = () => setOpen(false);

  const toggle = (e) => {
    e.stopPropagation();
    if (open) { setOpen(false); return; }
    if (openMenuRef && openMenuRef !== selfRef) openMenuRef.current(); // закрыть чужое
    openMenuRef = selfRef;
    const r = btnRef.current.getBoundingClientRect();
    const estH = items.length * 40 + 14;
    const openUp = r.bottom + estH > window.innerHeight - 10;
    const left = Math.max(150, r.right); // не уезжать за левый край (меню right-aligned)
    setPos({ top: openUp ? Math.max(10, r.top - estH - 6) : r.bottom + 6, left });
    setOpen(true);
  };

  useEffect(() => {
    if (!open) { if (openMenuRef === selfRef) openMenuRef = null; return; }
    const close = () => setOpen(false);
    const t = setTimeout(() => document.addEventListener('click', close), 0);
    window.addEventListener('scroll', close, true);
    window.addEventListener('resize', close);
    return () => { clearTimeout(t); document.removeEventListener('click', close); window.removeEventListener('scroll', close, true); window.removeEventListener('resize', close); };
  }, [open]); // eslint-disable-line

  return (
    <>
      <button ref={btnRef} className="cc-dots-btn" title="Действия" onClick={toggle} onPointerDown={e => e.stopPropagation()}><IcoDots /></button>
      {open && pos && createPortal(
        <div className="cc-menu" style={{ top: pos.top, left: pos.left }} onClick={e => e.stopPropagation()}>
          {items.map((it, i) => (
            <button key={i} className={`cc-menu-item${it.danger ? ' danger' : ''}`} disabled={it.disabled}
              onClick={() => { setOpen(false); it.onClick(); }}>{it.icon}<span>{it.label}</span></button>
          ))}
        </div>, document.body)}
    </>
  );
}
